import { CheckCircle2 } from 'lucide-react';

export default function About() {
  const values = [
    'Over 30 years of combined experience in real estate',
    'Proven track record of $150M+ in successful projects',
    'Deep understanding of market dynamics and trends',
    'Extensive network of industry connections',
    'Commitment to client success and transparency',
    'Expert viability analysis and risk assessment'
  ];

  const capabilities = [
    {
      title: 'Strategic Consulting',
      description: 'Our consultants bring decades of real estate expertise to every project, providing strategic insights that drive success.'
    },
    {
      title: 'Development Excellence',
      description: 'From initial concept through final delivery, we manage every aspect of project development with precision and care.'
    },
    {
      title: 'Investor Networks',
      description: 'We connect clients with strategic investment partners when projects require complex funding arrangements beyond traditional sources.'
    },
    {
      title: 'Market Intelligence',
      description: 'Our deep market knowledge and analysis capabilities ensure informed decision-making at every stage of your project.'
    }
  ];

  return (
    <div className="min-h-screen pt-20" data-testid="about-page">
      <section className="py-24 md:py-32 bg-[#020617]" data-testid="about-hero-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h1 className="text-5xl md:text-7xl font-medium tracking-tight leading-none text-[#f8fafc] mb-8" data-testid="about-title">
                <span className="text-[#d4af37]">30 Years</span><br />
                of Excellence
              </h1>
              <p className="text-lg md:text-xl leading-relaxed text-slate-300 mb-6">
                Jr Morales Investment Group Inc. was founded on the principle that successful real estate investment requires deep expertise, strategic vision, and unwavering commitment to client success.
              </p>
              <p className="text-lg md:text-xl leading-relaxed text-slate-300">
                Our team of seasoned investors and consultants each bring over 30 years of individual experience in real estate and major project development. This wealth of knowledge allows us to navigate complex markets and deliver exceptional results.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1758518727707-b023e285b709?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwYnVzaW5lc3MlMjBwZW9wbGUlMjBkaXNjdXNzaW5nJTIwcmVhbCUyMGVzdGF0ZSUyMGNoYXJ0cyUyMGx1eHVyeSUyMG9mZmljZXxlbnwwfHx8fDE3NjUxNTQ0MjV8MA&ixlib=rb-4.1.0&q=85"
                alt="Diverse business consultation"
                className="w-full h-full object-cover rounded-sm"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-[#0f172a]" data-testid="values-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <h2 className="text-4xl md:text-5xl font-normal tracking-tight text-[#f8fafc] mb-16 text-center">
            Our Foundation
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {values.map((value, index) => (
              <div
                key={index}
                data-testid={`value-item-${index}`}
                className="flex items-start space-x-4 glass-morphism p-6"
              >
                <CheckCircle2 className="text-[#d4af37] flex-shrink-0 mt-1" size={24} />
                <p className="text-base leading-relaxed text-slate-300">
                  {value}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-[#020617]" data-testid="capabilities-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <h2 className="text-4xl md:text-5xl font-normal tracking-tight text-[#f8fafc] mb-16 text-center">
            What Sets Us Apart
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {capabilities.map((capability, index) => (
              <div
                key={index}
                data-testid={`capability-card-${index}`}
                className="bg-slate-900/50 border border-white/5 p-8 hover:border-[#d4af37]/30 transition-all duration-500"
              >
                <h3 className="text-2xl md:text-3xl font-normal text-[#d4af37] mb-4">
                  {capability.title}
                </h3>
                <p className="text-base leading-relaxed text-slate-400">
                  {capability.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-[#0f172a]" data-testid="mission-section">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24 text-center">
          <h2 className="text-4xl md:text-5xl font-normal tracking-tight text-[#f8fafc] mb-8">
            Our Mission
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-slate-300 mb-6">
            To empower our clients with expert guidance, strategic partnerships, and comprehensive support throughout their real estate investment journey. We are committed to turning ambitious visions into successful, sustainable projects that create lasting value.
          </p>
          <p className="text-lg md:text-xl leading-relaxed text-slate-300">
            Whether you're developing a single property or managing a complex portfolio, Jr Morales Investment Group Inc. provides the expertise, connections, and dedication you need to succeed.
          </p>
        </div>
      </section>
    </div>
  );
}